/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef } from 'react';
import DataTable from 'react-data-table-component';
import Chat from './common/Chat';
import { prescript_documents } from '../assets/js/prescript_documents';
import { national_strategic_planning_development } from '../assets/js/national_strategic_planning_development';
import { governance_oversight } from '../assets/js/governance_oversight';
import { economic_growth_development_employment } from '../assets/js/economic_growth_development_employment';
import { climate_environment_sustainability } from '../assets/js/climate_environment_sustainability';
import { hosing_Legal_bot } from '../assets/js/hosing_Legal_bot';
import { housing_report_bot } from '../assets/js/housing_report_bot';
import { policy_programme } from '../assets/js/policy_programme';
import { prescripts_and_delegations } from '../assets/js/prescripts_and_delegations';
import { guidelines_manuals } from '../assets/js/guidelines_manuals';

//  Agriculture 
import { agriculture_annual_report } from "../assets/js/agriculture_annual_report";
import { agriculture_policy_framework } from "../assets/js/agriculture_policy_framework";

//  Dep of Cultural Affairs & Sport 
import { cultural_legislation } from "../assets/js/cultural_legislation";

//  Dep of Economic Development & Tourism 
import { ed_tourism_annual_report } from "../assets/js/ed_tourism_annual_report";

//  Department of Infrastructure 
import { doi_annual_report } from "../assets/js/doi_annual_report";
import { doi_policy_framework } from "../assets/js/doi_policy_framework";

//  Department of Local Government 
import { dlg_annual_report } from "../assets/js/dlg_annual_report";

//  Department of Premier 
import { dop_annual_report } from "../assets/js/dop_annual_report";
import { dop_legislation } from "../assets/js/dop_legislation";
import { dop_policy_framework } from "../assets/js/dop_policy_framework";

//  Department of Social Development 
import { dsd_policy_framework } from "../assets/js/dsd_policy_framework";

//  Treasury 
import { treasury_annual_report } from "../assets/js/treasury_annual_report";
import { treasury_legislation } from "../assets/js/treasury_legislation";
import { treasury_policy_framework } from "../assets/js/treasury_policy_framework";

//  DEADP 
import { deadp_annual_report } from "../assets/js/deadp_annual_report";
import { deadp_legislation } from "../assets/js/deadp_legislation";

//  Education 
import { wced_annual_report } from "../assets/js/wced_annual_report";
import { wced_policy_framework } from "../assets/js/wced_policy_framework";

//  Health & Wellness 
import { health_annual_report } from "../assets/js/health_annual_report";
import { health_policy_framework } from "../assets/js/health_policy_framework";

//  Mobility 
import { mobility_annual_report } from "../assets/js/mobility_annual_report";
import { mobility_legislation } from "../assets/js/mobility_legislation";
import { mobility_policy_framework } from "../assets/js/mobility_policy_framework";

import { useOutletContext } from 'react-router-dom';
import { agentAPIMap } from '../assets/js/constants';
import { Menu, MenuItem, SubMenu } from '@szhsin/react-menu';
import '@szhsin/react-menu/dist/index.css';
import rightarrow from '../assets/images/right-arrow.png';


export default function Docs() {
  const { selectedAgent } = useOutletContext(); //  Get selectedAgent from parent layout

  const [filterText, setFilterText] = useState('');
  const [customStyles, setCustomStyles] = useState({});
  const [showSummary, setShowSummary] = useState(false);  
  const [audioSrc, setAudioSrc] = useState('');
  const [isPlayingAudio, setIsPlayingAudio] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const apiBaseUrl = agentAPIMap[selectedAgent];
  const [selectedText, setSelectedText] = useState("");
  const [chatHistory, setChatHistory] = useState([]);
  const [apiHistory, setApiHistory] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [summaryUrl, setSummaryUrl] = useState("");

  const [mainCategory, setMainCategory] = useState("Housing"); // default
  const [subCategory, setSubCategory] = useState("Guidelines / Manuals"); // default sub

  const fetchAudioBlob = async (url) => {
    try {
      const response = await fetch(url, { mode: "cors" });
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const blob = await response.blob();
      return URL.createObjectURL(blob);
    } catch (error) {
      console.error("Error fetching audio blob:", error);
      return null;
    }
  };

  const handleResponse = (answer, question, extra = {}) => {
    setChatHistory((prev) => [...prev, { question, answer }]);
    if (extra.suggestions) setSuggestions(extra.suggestions);
    if (extra.chat_history) setApiHistory(extra.chat_history);
    setIsLoading(false);
  };

  const handleLoading = (val) => {
    setIsLoading(val);
  };

  useEffect(() => {
    const isLargeScreen = window.innerWidth >= 1900 && window.innerHeight >= 1000;

    const styles = {
      rows: {
        style: {
          minHeight: isLargeScreen ? '40px' : '32px',
          fontSize: isLargeScreen ? '14px' : '13px',
          paddingTop: '2px',
          paddingBottom: '2px',
        },
      },
      headCells: {
        style: {
          fontSize: isLargeScreen ? '15px' : '14px',
          fontWeight: '600',
          paddingTop: '2px',
          paddingBottom: '2px',
          // backgroundColor: '#f5f5f5',
        },
      },
    };

    setCustomStyles(styles);
  }, []);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getDocumentList = () => {
    switch (subCategory) {
      // Housing group
      case 'Guidelines / Manuals':
        return guidelines_manuals;
      case 'Legislation':
        return hosing_Legal_bot;
      case 'Policy / Programme Documents':
        return policy_programme;
      case 'Reports & Evaluations':
        return housing_report_bot;

      // Prescripts group
      case "Prescripts, Delegation & Case Law":
        return prescripts_and_delegations;
      case "Climate, Environment & Sustainability":
        return climate_environment_sustainability;
      case "Economic, growth development & Employment":
        return economic_growth_development_employment;
      case "Governance & Oversight":
        return governance_oversight;
      case "National Strategic Planning & Development":
        return national_strategic_planning_development;
      case "Spatial Planning & Infrastructure":
        return prescript_documents;

      // Agriculture 
      case "Agriculture - Annual Report":
        return agriculture_annual_report;
      case "Agriculture - Policy Framework":
        return agriculture_policy_framework;

      // Cultural Affairs and Sport 
      case "Dep of Cultural Affairs and Sport - Legislation":
        return cultural_legislation;

      // Economic Development & Tourism 
      case "Dep of Economic Development and Tourism - Annual Report":
        return ed_tourism_annual_report;

      // Department of Infrastructure 
      case "Department of Infrastructure - Annual Report":
        return doi_annual_report;
      case "Department of Infrastructure - Policy Framework":
        return doi_policy_framework;

      // Department of Local Government 
      case "Department of Local Government - Annual Report":
        return dlg_annual_report;

      // Department of Premier 
      case "Department of Premier - Annual Report":
        return dop_annual_report;
      case "Department of Premier - Legislation":
        return dop_legislation;
      case "Department of Premier - Policy Framework":
        return dop_policy_framework;

      // Social Development 
      case "Department of Social Development - Policy Framework":
        return dsd_policy_framework;

      // Treasury 
      case "Treasury - Annual Report":
        return treasury_annual_report;
      case "Treasury - Legislation":
        return treasury_legislation;
      case "Treasury - Policy Framework":
        return treasury_policy_framework;

      // DEADP 
      case "Department of Environmental Affairs and Development Planning (DEADP) - Annual Report":
        return deadp_annual_report;
      case "Department of Environmental Affairs and Development Planning (DEADP) - Legislation":
        return deadp_legislation;

      // Education 
      case "Western Cape Education Department - Annual Report":
        return wced_annual_report;
      case "Western Cape Education Department - Policy Framework":
        return wced_policy_framework;

      // Health & Wellness 
      case "Western Cape Government Health and Wellness - Annual Report":
        return health_annual_report;
      case "Western Cape Government Health and Wellness - Policy Framework":
        return health_policy_framework;

      // Mobility Department 
      case "Western Cape Mobility Department - Annual Report":
        return mobility_annual_report;
      case "Western Cape Mobility Department - Legislation":
        return mobility_legislation;
      case "Western Cape Mobility Department - Policy Framework":
        return mobility_policy_framework;

      default:
        return [];
    }
  };

  const allDocuments = getDocumentList();

  const filteredDocuments = allDocuments.filter((item) => {
    const searchText = filterText.toLowerCase();
    return (
      (item.name && item.name.toLowerCase().includes(searchText)) ||
      (item.id && item.id.toString().includes(searchText))
    );
  });

  const handleSummaryClick = (summaryPath) => {
    if (!summaryPath || !summaryPath.endsWith(".html")) {
      alert("No summary available for this document.");
      return;
    }

    setSummaryUrl(summaryPath);
    setShowSummary(true);
  };

  const closeModal = () => {
    setShowSummary(false);    
    setSummaryUrl("");
  };

  const columns = [
    {
      name: '#',
      selector: (row) => row.id,
      width: '10%',
    },
    {
      name: 'Strategies, policies and prescript documents',
      selector: (row) => row.name,
      sortable: true,
      width: '60%',
    },
    {
      name: 'Action',
      cell: (row) => (
        <div className="action">
          {/* Summary */}
          <a
            onClick={() => {
              if (!row.summary || row.summary.trim() === "") {
                alert("No summary available for this document.");
                return;
              }
              handleSummaryClick(`${process.env.REACT_APP_DOCUMENT_PATH}${row.summary}`);
            }}
          >
            <i className="fa-solid fa-receipt hoverPrimary summaryicon" title="Summary"></i>
          </a>

          {/* Full Document */}
          <a
            href={
              row.link && row.link.trim() !== ""
                ? `${process.env.REACT_APP_DOCUMENT_PATH}${row.link}`
                : undefined
            }
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => {
              if (!row.link || row.link.trim() === "") {
                e.preventDefault();
                alert("No document available.");
              }
            }}
          >
            <i
              className="fa-solid fa-file-lines hoverPrimary summaryicon"
              title="Full Doc"
            ></i>
          </a>

          {/* Audio */}
          <a
            onClick={() => {
              if (!row.audio_en || row.audio_en.trim() === "") {
                alert("No audio available for this document.");
                return;
              }

              // If the JSON already contains the correct URL (local or full link)
              const directAudio = row.audio_en.startsWith("http")
                ? row.audio_en
                : `${process.env.REACT_APP_DOCUMENT_PATH}${row.audio_en}`;

              setAudioSrc(directAudio);
              setIsPlayingAudio(true);
            }}
          >
            <i
              className="fa-solid fa-volume-high hoverPrimary summaryicon"
              title="Play Audio English"
            ></i>
          </a>
        </div>
      ),
    }
  ];  

  return (
    <div>
      <div className="bottom_header">
        <h2 className="title">Source Documents</h2>


        {/* Parent Menu */}
       <Menu
          menuButton={
            <button className="select-btn docsdropdown">
              {mainCategory}
              <img src={rightarrow} className="docsdropdownarrow" alt="icon" />

              {/* CLEAN SUBCATEGORY DISPLAY */}
              {subCategory.replace(`${mainCategory} - `, "")}

              <i className="fa-solid fa-chevron-down"></i>
            </button>
          }
        >
          {/* Housing Group */}
          <SubMenu
            label="Housing"
            onClick={() => setMainCategory("Housing")}
          >
            <MenuItem
              onClick={() => {
                setMainCategory("Housing");
                setSubCategory("Guidelines / Manuals");
              }}
            >
              Guidelines / Manuals
            </MenuItem>
            <MenuItem
              onClick={() => {
                setMainCategory("Housing");
                setSubCategory("Legislation");
              }}
            >
              Legislation
            </MenuItem>
            <MenuItem
              onClick={() => {
                setMainCategory("Housing");
                setSubCategory("Policy / Programme Documents");
              }}
            >
              Policy / Programme Documents
            </MenuItem>
            <MenuItem
              onClick={() => {
                setMainCategory("Housing");
                setSubCategory("Reports & Evaluations");
              }}
            >
              Reports & Evaluations
            </MenuItem>
          </SubMenu>

          {/* Prescripts Group */}
          <SubMenu
            label="Prescripts"
            onClick={() => setMainCategory("Prescripts")}
          >
            <MenuItem
              onClick={() => {
                setMainCategory("Prescripts");
                setSubCategory("Prescripts, Delegation & Case Law");
              }}
            >
              Prescripts, Delegation & Case Law
            </MenuItem>
            <MenuItem
              onClick={() => {
                setMainCategory("Prescripts");
                setSubCategory("Climate, Environment & Sustainability");
              }}
            >
              Climate, Environment & Sustainability
            </MenuItem>
            <MenuItem
              onClick={() => {
                setMainCategory("Prescripts");
                setSubCategory("Economic, growth development & Employment");
              }}
            >
              Economic, growth development & Employment
            </MenuItem>
            <MenuItem
              onClick={() => {
                setMainCategory("Prescripts");
                setSubCategory("Governance & Oversight");
              }}
            >
              Governance & Oversight
            </MenuItem>
            <MenuItem
              onClick={() => {
                setMainCategory("Prescripts");
                setSubCategory("National Strategic Planning & Development");
              }}
            >
              National Strategic Planning & Development
            </MenuItem>
            <MenuItem
              onClick={() => {
                setMainCategory("Prescripts");
                setSubCategory("Spatial Planning & Infrastructure");
              }}
            >
              Spatial Planning & Infrastructure
            </MenuItem>
          </SubMenu>

          {/* Agriculture */}
          <SubMenu
            label="Agriculture"
            onClick={() => setMainCategory("Agriculture")}
          >
            <MenuItem
              onClick={() => {
                setMainCategory("Agriculture");
                setSubCategory("Agriculture - Annual Report");
              }}
            >
              Annual Report
            </MenuItem>
            <MenuItem
              onClick={() => {
                setMainCategory("Agriculture");
                setSubCategory("Agriculture - Policy Framework");
              }}
            >
              Policy Framework
            </MenuItem>
          </SubMenu>

          {/* Dep of Cultural Affairs and Sport */}
          <SubMenu
            label="Dep of Cultural Affairs and Sport"
            onClick={() => setMainCategory("Dep of Cultural Affairs and Sport")}
          >
            <MenuItem
              onClick={() => {
                setMainCategory("Dep of Cultural Affairs and Sport");
                setSubCategory("Dep of Cultural Affairs and Sport - Legislation");
              }}
            >
              Legislation
            </MenuItem>
          </SubMenu>

          {/* Dep of Economic Development and Tourism */}
          <SubMenu
            label="Dep of Economic Development and Tourism"
            onClick={() => setMainCategory("Dep of Economic Development and Tourism")}
          >
            <MenuItem
              onClick={() => {
                setMainCategory("Dep of Economic Development and Tourism");
                setSubCategory("Dep of Economic Development and Tourism - Annual Report");
              }}
            >
              Annual Report
            </MenuItem>
          </SubMenu>

          {/* Department of Infrastructure */}
          <SubMenu
            label="Department of Infrastructure"
            onClick={() => setMainCategory("Department of Infrastructure")}
          >
            <MenuItem
              onClick={() => {
                setMainCategory("Department of Infrastructure");
                setSubCategory("Department of Infrastructure - Annual Report");
              }}
            >
              Annual Report
            </MenuItem>
            <MenuItem
              onClick={() => {
                setMainCategory("Department of Infrastructure");
                setSubCategory("Department of Infrastructure - Policy Framework");
              }}
            >
              Policy Framework
            </MenuItem>
          </SubMenu>

          {/* Department of Local Government */}
          <SubMenu
            label="Department of Local Government"
            onClick={() => setMainCategory("Department of Local Government")}
          >
            <MenuItem
              onClick={() => {
                setMainCategory("Department of Local Government");
                setSubCategory("Department of Local Government - Annual Report");
              }}
            >
              Annual Report
            </MenuItem>
          </SubMenu>

          {/* Department of Premier */}
          <SubMenu
            label="Department of Premier"
            onClick={() => setMainCategory("Department of Premier")}
          >
            <MenuItem
              onClick={() => {
                setMainCategory("Department of Premier");
                setSubCategory("Department of Premier - Annual Report");
              }}
            >
              Annual Report
            </MenuItem>
            <MenuItem
              onClick={() => {
                setMainCategory("Department of Premier");
                setSubCategory("Department of Premier - Legislation");
              }}
            >
              Legislation
            </MenuItem>
            <MenuItem
              onClick={() => {
                setMainCategory("Department of Premier");
                setSubCategory("Department of Premier - Policy Framework");
              }}
            >
              Policy Framework
            </MenuItem>
          </SubMenu>

          {/* Department of Social Development */}
          <SubMenu
            label="Department of Social Development"
            onClick={() => setMainCategory("Department of Social Development")}
          >
            <MenuItem
              onClick={() => {
                setMainCategory("Department of Social Development");
                setSubCategory("Department of Social Development - Policy Framework");
              }}
            >
              Policy Framework
            </MenuItem>
          </SubMenu>

          {/* Treasury */}
          <SubMenu label="Treasury" onClick={() => setMainCategory("Treasury")}>
            <MenuItem
              onClick={() => {
                setMainCategory("Treasury");
                setSubCategory("Treasury - Annual Report");
              }}
            >
              Annual Report
            </MenuItem>
            <MenuItem
              onClick={() => {
                setMainCategory("Treasury");
                setSubCategory("Treasury - Legislation");
              }}
            >
              Legislation
            </MenuItem>
            <MenuItem
              onClick={() => {
                setMainCategory("Treasury");
                setSubCategory("Treasury - Policy Framework");
              }}
            >
              Policy Framework
            </MenuItem>
          </SubMenu>

          {/* DEADP */}
          <SubMenu
            label="Department of Environmental Affairs and Development Planning (DEADP)"
            onClick={() =>
              setMainCategory(
                "Department of Environmental Affairs and Development Planning (DEADP)"
              )
            }
          >
            <MenuItem
              onClick={() => {
                setMainCategory(
                  "Department of Environmental Affairs and Development Planning (DEADP)"
                );
                setSubCategory("Department of Environmental Affairs and Development Planning (DEADP) - Annual Report");
              }}
            >
              Annual Report
            </MenuItem>
            <MenuItem
              onClick={() => {
                setMainCategory(
                  "Department of Environmental Affairs and Development Planning (DEADP)"
                );
                setSubCategory("Department of Environmental Affairs and Development Planning (DEADP) - Legislation");
              }}
            >
              Legislation
            </MenuItem>
          </SubMenu>

          {/* Western Cape Education Department */}
          <SubMenu
            label="Western Cape Education Department"
            onClick={() => setMainCategory("Western Cape Education Department")}
          >
            <MenuItem
              onClick={() => {
                setMainCategory("Western Cape Education Department");
                setSubCategory("Western Cape Education Department - Annual Report");
              }}
            >
              Annual Report
            </MenuItem>
            <MenuItem
              onClick={() => {
                setMainCategory("Western Cape Education Department");
                setSubCategory("Western Cape Education Department - Policy Framework");
              }}
            >
              Policy Framework
            </MenuItem>
          </SubMenu>

          {/* Western Cape Government Health and Wellness */}
          <SubMenu
            label="Western Cape Government Health and Wellness"
            onClick={() =>
              setMainCategory("Western Cape Government Health and Wellness")
            }
          >
            <MenuItem
              onClick={() => {
                setMainCategory("Western Cape Government Health and Wellness");
                setSubCategory(
                  "Western Cape Government Health and Wellness - Annual Report"
                );
              }}
            >
              Annual Report
            </MenuItem>
            <MenuItem
              onClick={() => {
                setMainCategory("Western Cape Government Health and Wellness");
                setSubCategory(
                  "Western Cape Government Health and Wellness - Policy Framework"
                );
              }}
            >
              Policy Framework
            </MenuItem>
          </SubMenu>

          {/* Western Cape Mobility Department */}
          <SubMenu
            label="Western Cape Mobility Department"
            onClick={() => setMainCategory("Western Cape Mobility Department")}
          >
            <MenuItem
              onClick={() => {
                setMainCategory("Western Cape Mobility Department");
                setSubCategory("Western Cape Mobility Department - Annual Report");
              }}
            >
              Annual Report
            </MenuItem>
            <MenuItem
              onClick={() => {
                setMainCategory("Western Cape Mobility Department");
                setSubCategory("Western Cape Mobility Department - Legislation");
              }}
            >
              Legislation
            </MenuItem>
            <MenuItem
              onClick={() => {
                setMainCategory("Western Cape Mobility Department");
                setSubCategory("Western Cape Mobility Department - Policy Framework");
              }}
            >
              Policy Framework
            </MenuItem>
          </SubMenu>


        </Menu>

        <div className="search-input-box">
          <input
            type="text"
            placeholder="Search document..."
            value={filterText}
            onChange={(e) => setFilterText(e.target.value)}
          />
        </div>
      </div>

      <DataTable
        columns={columns}
        data={filteredDocuments}
        striped
        pagination
        highlightOnHover
        persistTableHead
        customStyles={customStyles}
        paginationPerPage={rowsPerPage}
        onChangePage={(page) => setCurrentPage(page)}
        onChangeRowsPerPage={(newPerPage, page) => {
          setRowsPerPage(newPerPage);
          setCurrentPage(page);
        }}
      />

      {/* Summary Modal */}
      {showSummary && (
        <div className="popup-backdrop">
          <div className="popup-modal">            
            <div className='popupdiv'>
              <iframe
                src={summaryUrl}
                width="100%"                
                style={{ border: "none", borderRadius: "8px"}}
                title="Summary Document"
              />
            </div>
            <button className="btn btn-primary mt-2" onClick={closeModal}>Close</button>
          </div>
        </div>
      )}

      {/* Audio Popup */}
      {isPlayingAudio && (
        <div className="audio-player-popup">
          <audio src={audioSrc} 
                  controls 
                  autoPlay 
                  onEnded={() => setIsPlayingAudio(false)} 
          />
          <i
            className="fa-solid fa-circle-xmark hoverPrimary closevolumn"
            title="Close Player"
            style={{ cursor: 'pointer', fontSize: '18px', float: 'right' }}
            onClick={() => setIsPlayingAudio(false)}
          ></i>
        </div>
      )}

      <Chat
        selectedText={selectedText}
        onResponse={handleResponse}
        onLoading={handleLoading}
        apiBaseUrl={apiBaseUrl}
      />
    </div>
  );
}